import Vue from 'vue'
import TableRender from './TableRender'

// 是否空值
const isEmptyVal = val => !val && val !== 0

// 列表 - 单元格
export default {
  name: 'TableCell',
  components: { TableRender },
  inject: ['Table', 'Row'],
  props: {
    row: {
      type: Object,
      required: true
    },

    col: {
      type: Object,
      required: true
    }
  },

  render() {
    const { col } = this
    return (
      <td width={col.width} class={col.cellClass}>
        {this.renderCell()}
      </td>
    )
  },

  computed: {
    prop() {
      return this.col.prop
    },

    index() {
      return this.Row.index
    },

    value() {
      return this.row[this.prop]
    },

    formatValue() {
      const { formatter } = this.col
      if (formatter) {
        return formatter(this.row, this.col, this.value, this.index)
      }
      return this.value
    }
  },

  methods: {
    renderCell() {
      const { row, col, prop, value, index, Row, Table } = this

      // 自定义渲染 jsx
      if (col.render) {
        return <table-render render={col.render} row={row} value={value} index={index} />
      }

      // prop 插槽
      const cellSlot = Table.$scopedSlots[col.slot] || Table.$scopedSlots[prop]

      if (cellSlot) {
        return cellSlot({ row, value, index })
      }

      // 多选 checkbox
      if (col.type === 'checkbox') {
        const { isSelected } = Row
        const checkBoxStatCls = (isSelected && '-on') || (!Row.selectable && '-not')
        const checkBoxCls = 'fdd-radio' + (checkBoxStatCls || '')

        return (
          <label class={checkBoxCls} onClick={() => Table.select(row, !isSelected)}>
            <span class="use-icon_radio"></span>
          </label>
        )
      }

      let cellValue = Vue.filter('empty')(this.formatValue)

      // 单行截断 popover 提示
      if (cellValue && col.popover) {
        return (
          <fdd-tooltip content={cellValue} disabled={!this.formatValue}>
            <span class="text-hide">{cellValue}</span>
          </fdd-tooltip>
        )
      }

      return cellValue
    }
  }
}
